<ion-header>
	<ion-toolbar>
		<ion-title>{{ modalHeaderTitle }}</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="dismiss()">{{ 'CLOSE' | translate }}</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content>
	<iframe [src]="sanitizedUrl" width="100" height="100" style="border: none"></iframe>
</ion-content>
